import type { ComponentPropsWithoutRef } from "react";

import { type FullAirHandlerUnit } from "@eisox/api/core-api";
import { cn, Heading } from "@eisox/design-system";

import { SchemeWrapper } from "~/components/scheme-wrapper";

import { AirHandlerUnit } from "./air-handler-unit";
import { GroupNavigation, type FocusRequest } from "./group-navigation";

const NAME = "Scheme";

interface SchemeProps extends ComponentPropsWithoutRef<"div"> {
  buildingId: string;
  airHandlerUnit: FullAirHandlerUnit[];
  loading?: boolean;
  focusRequest?: FocusRequest;
}

export const Scheme: React.FC<SchemeProps> = ({
  buildingId,
  airHandlerUnit,
  loading,
  focusRequest,
  className,
  children,
  ...props
}) => (
  <div
    {...props}
    className={cn(
      "min-w-0 min-h-0 flex flex-col items-center justify-center rounded-[10px] bg-primary-white",
      className,
    )}
  >
    <SchemeWrapper
      loading={loading}
      className="gap-12.5 flex flex-col items-center"
      controls={
        airHandlerUnit.length > 1 && (
          <GroupNavigation
            key={airHandlerUnit.map(ahu => ahu.id).join()}
            airHandlerUnit={airHandlerUnit}
            focusRequest={focusRequest}
          />
        )
      }
    >
      {airHandlerUnit.map(ahu => (
        <div key={ahu.id} data-air-handler-unit-id={ahu.id} className="gap-5 flex flex-col items-center">
          {airHandlerUnit.length > 1 && (
            <Heading as="h3" size={4}>
              {ahu.name}
            </Heading>
          )}
          <AirHandlerUnit buildingId={buildingId} airHandlerUnit={ahu} />
        </div>
      ))}
    </SchemeWrapper>
    {children}
  </div>
);

Scheme.displayName = NAME;
